// Same cap and character set the server enforces (routes/fanAuth.js IG_RE):
// strip a leading "@", keep letters, digits, dots and underscores, max 30.
// Sanitizing as they type beats a silent 400 on save.
export function sanitizeInstagramHandle(raw: string): string {
  return raw.replace(/^@+/, "").replace(/[^a-zA-Z0-9._]/g, "").slice(0, 30);
}
